export function Label({ className = "", children, ...props }) {
    const classes = ["aurora-label", className].filter(Boolean).join(" ")
    return (
        <label className={classes} {...props}>
            {children}
        </label>
    )
}

export default Label




